"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownButton = DropdownButton;
exports.DropdownButtonWithPopover = DropdownButtonWithPopover;
var React = _interopRequireWildcard(require("react"));
var _hooks = require("../../common/hooks");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _Popover = require("../popover/Popover");
var _Button = require("./Button");
var _excluded = ["isOpen"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function DropdownButton(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    props = _objectWithoutProperties(_ref, _excluded);
  var rightIcon = /*#__PURE__*/React.createElement(_Icon.Icon8, {
    icon: isOpen ? _iconNames.IconNames8.CARET_UP : _iconNames.IconNames8.CARET_DOWN
  });
  return /*#__PURE__*/React.createElement(_Button.Button, _extends({}, props, {
    rightIcon: rightIcon
  }));
}
/**
 * This is a thin wrapper around the Dropdown Button that allows us to add in the
 * visibility functionality that would normally be provided by its implementation
 */
function DropdownButtonWithPopover(_ref2) {
  var children = _ref2.children,
    buttonProps = _ref2.buttonProps,
    popoverProps = _ref2.popoverProps;
  var _useVisibility = (0, _hooks.useVisibility)(false),
    isOpen = _useVisibility.isOpen,
    handleOpen = _useVisibility.handleOpen,
    handleClose = _useVisibility.handleClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Popover.Popover, _extends({
    isOpen: isOpen,
    onClose: handleClose
  }, popoverProps), /*#__PURE__*/React.createElement(DropdownButton, _extends({}, buttonProps, {
    onClick: handleOpen,
    isOpen: isOpen
  })), children));
}